import { Tag } from "lucide-react";
import { Button } from "../../client/components/ui/button";
import { Checkbox } from "../../client/components/ui/checkbox";
import { Popover, PopoverContent, PopoverTrigger } from "../../client/components/ui/popover";
import useTranslation from "../../client/hooks/useTranslation";

export default function TopbarTagsFilterWidget({
  tags,
  selectedIds,
  onChange,
}: {
  tags: any[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}) {
  const t = useTranslation();
  const toggle = (id: string) => {
    onChange(selectedIds.includes(id) ? selectedIds.filter((x) => x !== id) : [...selectedIds, id]);
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-9 text-sm gap-1.5">
          <Tag className="h-3.5 w-3.5" />
          {t.journal.tagsFilterLabel}
          {selectedIds.length > 0 && (
            <span className="ml-1 text-[10px] font-mono rounded-full bg-primary/15 text-primary px-1.5">{selectedIds.length}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56 max-h-72 overflow-y-auto" align="end">
        {tags.length === 0 ? (
          <p className="text-xs text-muted-foreground py-2 text-center">{t.journal.noTagsAvailable}</p>
        ) : (
          <div className="space-y-1.5">
            {tags.map((tag: any) => (
              <label key={tag.id} className="flex items-center gap-2 text-sm cursor-pointer py-0.5">
                <Checkbox checked={selectedIds.includes(tag.id)} onCheckedChange={() => toggle(tag.id)} />
                <span className="truncate">{tag.name}</span>
              </label>
            ))}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
